/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminActionLogDto } from '../../models/admin-action-log-dto';

export interface AdminActionLogControllerFindAll$Params {
}

export function adminActionLogControllerFindAll(http: HttpClient, rootUrl: string, params?: AdminActionLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdminActionLogDto>>> {
  const rb = new RequestBuilder(rootUrl, adminActionLogControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AdminActionLogDto>>;
    })
  );
}

adminActionLogControllerFindAll.PATH = '/api/admin-action-log';
